import type { ReactNode } from 'react'

import { PUBLIC_BANNER_SURFACE, PUBLIC_IMAGE_OUTLINE } from '@/components/public/public-surfaces'
import { TenantLogoWatermark } from '@/components/ui/tenant-logo-watermark'
import { cn } from '@/lib/utils'

/** Overlapping identity sits on the centered reading column, not the wider banner. */
export const PUBLIC_ENTITY_IDENTITY_OVERLAP_CLASS =
  'absolute top-full z-[2] -translate-y-1/2 left-[max(0px,calc((100%-var(--public-share-body-max-width,100%))/2))]'

type PublicEntityHeroProps = {
  bannerUrl?: string | null
  identity: ReactNode
  className?: string
}

/** Read-only banner + overlapping identity image for public share pages (h-60 + 120px overlap). */
export function PublicEntityHero({ bannerUrl, identity, className }: PublicEntityHeroProps) {
  return (
    <section className={cn('relative overflow-visible', className)}>
      <div className={PUBLIC_BANNER_SURFACE}>
        <div className="relative flex h-60 w-full shrink-0 overflow-hidden">
          {bannerUrl ? (
            <img
              src={bannerUrl}
              alt=""
              className={cn('h-full w-full object-cover', PUBLIC_IMAGE_OUTLINE)}
            />
          ) : (
            <div className="relative isolate h-full w-full">
              <TenantLogoWatermark />
            </div>
          )}
        </div>
      </div>
      <div className={PUBLIC_ENTITY_IDENTITY_OVERLAP_CLASS}>{identity}</div>
    </section>
  )
}
